import React from 'react';
import FieldWrapper from '../../fields/FieldWrapper';
import TagsInput from '../../../Form/TagsInput';

const TagsFieldInput = ({
  label,
  value,
  onChange,
  helperText,
  disabled,
  required,
  columnStyle,
  options,
}) => {
  const normalizedValue = Array.isArray(value) ? value : [];

  return (
    <FieldWrapper style={columnStyle}>
      <TagsInput
        label={label}
        value={normalizedValue}
        onChange={onChange}
        options={options}
        required={required}
        helperText={helperText}
        disabled={disabled}
      />
    </FieldWrapper>
  );
};

export default TagsFieldInput;
